/* SANTO sticky add-to-cart bar. Mirrors the main product form (variant-selects) and submits through it. */
(function () {
  'use strict';
  if (window.__santoSticky) return;
  window.__santoSticky = true;

  var FORM_SEL = 'product-form form[action$="/cart/add"]';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat((window.Shopify && Shopify.locale) || 'en-GB', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function init() {
    var form = $(FORM_SEL);
    if (!form || !/\/products\//.test(location.pathname)) return;
    var handle = location.pathname.split('/products/')[1].split(/[/?#]/)[0];
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(build).catch(function () {});
  }

  function build(product) {
    var hasOptions = !(product.variants.length === 1 && product.options.length === 1 && product.variants[0].title === 'Default Title');
    var opts = hasOptions ? product.options.map(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      var values = o.values || product.variants.map(function (v) { return v.options[i]; }).filter(function (v, j, a) { return a.indexOf(v) === j; });
      return { name: name, values: values, index: i, isSize: /size|taglia|größe|taille/i.test(name), isColor: /colou?r/i.test(name) };
    }) : [];
    var sizeOpt = opts.filter(function (o) { return o.isSize; })[0];
    var sizeChosen = !sizeOpt || /[?&]variant=/.test(location.search);

    var bar = document.createElement('div');
    bar.className = 'santo-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="santo-sticky__msg" role="alert"></div>' +
      '<div class="santo-sticky__inner">' +
        '<div class="santo-sticky__info"><img class="santo-sticky__thumb" alt="" width="44" height="44" loading="lazy">' +
          '<div class="santo-sticky__text"><p class="santo-sticky__title">' + esc(product.title) + '</p><div class="santo-sticky__price"></div></div></div>' +
        '<div class="santo-sticky__opts">' + opts.map(function (o) {
          return '<div class="santo-sticky__group" data-index="' + o.index + '"><span class="santo-sticky__label">' + esc(o.isColor ? 'Colour' : o.name) + '</span>' +
            '<div class="santo-sticky__vals" role="group" aria-label="' + esc(o.name) + '">' + o.values.map(function (v) {
              return '<button type="button" class="santo-sticky__opt" data-value="' + esc(v) + '" aria-pressed="false" aria-label="' + esc(o.name + ': ' + v) + '">' + (o.isColor ? '' : esc(v)) + '</button>';
            }).join('') + '</div></div>';
        }).join('') + '</div>' +
        '<button type="button" class="santo-sticky__btn">Add to cart</button>' +
      '</div>';
    document.body.appendChild(bar);

    var btn = $('.santo-sticky__btn', bar), msg = $('.santo-sticky__msg', bar);
    var priceEl = $('.santo-sticky__price', bar), thumb = $('.santo-sticky__thumb', bar);
    var sel = [];

    // Colour buttons: variant image, else the theme's swatch image, else text.
    opts.forEach(function (o) {
      if (!o.isColor) return;
      $$('.santo-sticky__group[data-index="' + o.index + '"] .santo-sticky__opt', bar).forEach(function (b) {
        var v = b.getAttribute('data-value'), bg = '';
        var vv = product.variants.filter(function (x) { return x.options[o.index] === v && x.featured_image; })[0];
        if (vv) bg = 'url("' + vv.featured_image.src + (vv.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=100")';
        if (!bg) {
          var inp = mainInput(o.index, v), lab = inp && inp.id && $('label[for="' + inp.id + '"]');
          if (lab) { var bi = getComputedStyle(lab).backgroundImage; if (bi && bi !== 'none') bg = bi; }
        }
        if (bg) { b.classList.add('santo-sticky__opt--swatch'); b.style.backgroundImage = bg; }
        else b.textContent = v;
      });
    });

    function fieldsets() { var vs = $('variant-selects'); return vs ? $$('fieldset, .product-form__input--dropdown, select', vs).filter(function (el) { return el.tagName === 'FIELDSET' || el.tagName === 'SELECT'; }) : []; }
    function mainInput(i, v) {
      var fs = fieldsets()[i];
      if (!fs) return null;
      if (fs.tagName === 'SELECT') return fs;
      return $$('input', fs).filter(function (x) { return x.value === v; })[0] || null;
    }
    function readMain() {
      var out = [];
      fieldsets().forEach(function (fs, i) {
        if (fs.tagName === 'SELECT') out[i] = fs.value;
        else { var c = $('input:checked', fs); out[i] = c ? c.value : null; }
      });
      return out;
    }
    function findVariant(s) {
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === s[i]; }); })[0] || null;
    }
    function current() { return hasOptions ? findVariant(sel) : product.variants[0]; }

    function render() {
      var v = current() || product.variants[0];
      priceEl.classList.toggle('is-sale', !!(v.compare_at_price && v.compare_at_price > v.price));
      priceEl.innerHTML = '<span>' + money(v.price) + '</span>' + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
      var img = (v.featured_image && v.featured_image.src) || product.featured_image;
      if (img) { img = (img.indexOf('//') === 0 ? 'https:' + img : img); thumb.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }
      opts.forEach(function (o) {
        $$('.santo-sticky__group[data-index="' + o.index + '"] .santo-sticky__opt', bar).forEach(function (b) {
          var val = b.getAttribute('data-value');
          var pressed = sel[o.index] === val && (!o.isSize || sizeChosen);
          b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
          // availability given the other selected options
          var test = sel.slice(); test[o.index] = val;
          var tv = findVariant(test), out = !tv || !tv.available;
          b.classList.toggle('is-soldout', out);
          b.setAttribute('aria-disabled', out ? 'true' : 'false');
          b.title = out ? val + ' - sold out' : val;
        });
      });
      var cv = current();
      btn.classList.remove('is-unset');
      btn.disabled = false;
      if (!sizeChosen) { btn.textContent = 'Select a size'; btn.classList.add('is-unset'); }
      else if (!cv || !cv.available) { btn.textContent = 'Sold out'; btn.disabled = true; }
      else btn.textContent = 'Add to cart';
    }

    function sync() { if (hasOptions) { sel = readMain(); } render(); }

    function prompt(text) {
      msg.textContent = text; msg.classList.add('is-on');
      var g = sizeOpt && $('.santo-sticky__group[data-index="' + sizeOpt.index + '"]', bar);
      if (g) { g.classList.remove('is-prompt'); void g.offsetWidth; g.classList.add('is-prompt'); var f = $('.santo-sticky__opt:not(.is-soldout)', g); if (f) f.focus(); }
      clearTimeout(prompt.t); prompt.t = setTimeout(function () { msg.classList.remove('is-on'); if (g) g.classList.remove('is-prompt'); }, 2600);
    }

    // Bar -> main form
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('.santo-sticky__opt');
      if (!b) return;
      var i = +b.closest('.santo-sticky__group').getAttribute('data-index'), val = b.getAttribute('data-value');
      if (b.classList.contains('is-soldout') && !(opts[i].isColor)) return;
      if (sizeOpt && i === sizeOpt.index) { sizeChosen = true; msg.classList.remove('is-on'); b.closest('.santo-sticky__group').classList.remove('is-prompt'); }
      sel[i] = val;
      render();
      var inp = mainInput(i, val);
      if (!inp) return;
      bar.__fromBar = true;
      if (inp.tagName === 'SELECT') inp.value = val; else inp.checked = true;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      bar.__fromBar = false;
    });

    // Main form -> bar
    document.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('variant-selects')) return;
      if (!bar.__fromBar && sizeOpt && e.isTrusted) {
        var fs = e.target.closest('fieldset') || e.target;
        if (fieldsets().indexOf(fs) === sizeOpt.index) sizeChosen = true;
      }
      setTimeout(sync, 30); setTimeout(sync, 800);
    });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { sync(); watchAtc(); }, 30); });
    }

    // Submit through the real form so the theme's cart drawer handles it.
    btn.addEventListener('click', function () {
      if (!sizeChosen) { prompt('Pick your size first'); return; }
      var v = current();
      if (!v || !v.available) return;
      btn.disabled = true; btn.textContent = 'Adding...';
      var tries = 0;
      (function go() {
        var f = $(FORM_SEL), idIn = f && f.querySelector('[name="id"]'), sb = f && f.querySelector('[type="submit"]');
        var ready = idIn && String(idIn.value) === String(v.id) && sb && sb.getAttribute('aria-disabled') !== 'true' && !sb.classList.contains('loading');
        if (!ready && tries++ < 20) { setTimeout(go, 100); return; }
        if (!f) return;
        if (idIn) { idIn.value = v.id; idIn.disabled = false; }
        if (sb) sb.removeAttribute('aria-disabled');
        if (f.requestSubmit) f.requestSubmit(); else if (sb) sb.click();
        setTimeout(render, 1500);
      })();
    });

    // Visibility: show once the main ATC is scrolled above the viewport, hide over the footer.
    var atcOut = false, footerIn = false, watched = null;
    function update() {
      var on = atcOut && !footerIn;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if ('inert' in bar) bar.inert = !on;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.target.matches('footer, .footer, .shopify-section-group-footer-group')) footerIn = en.isIntersecting;
        else atcOut = !en.isIntersecting && en.boundingClientRect.top < 0;
      });
      update();
    });
    function watchAtc() {
      var el = $(FORM_SEL + ' [type="submit"]') || $(FORM_SEL);
      if (el && el !== watched) { if (watched) io.unobserve(watched); watched = el; io.observe(el); }
    }
    watchAtc();
    var foot = $('.shopify-section-group-footer-group') || $('footer');
    if (foot) io.observe(foot);

    // Theme preview only: lift the bar above Shopify's preview bar (it can be collapsed, so keep checking).
    var pbTries = 0;
    (function pbar() {
      var w = $('#PBarNextFrameWrapper, #preview-bar-iframe');
      if (w) {
        document.documentElement.classList.add('santo-preview');
        var r = w.getBoundingClientRect();
        bar.style.bottom = (r.height && r.top < innerHeight ? Math.max(0, Math.round(innerHeight - r.top)) : 0) + 'px';
      }
      if (w || pbTries++ < 10) setTimeout(pbar, w ? 1000 : 500);
    })();
    if (reduce) bar.style.transition = 'none';
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();